/**
 * EventsTimelineCell Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import get from 'lodash.get';

// Selectors
import { selectGroupedData } from '../../../../selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectGroupId = (_state, { groupId }) => groupId;
const selectDate = (_state, { date }) => date;

const makeSelectEventUuids = () =>
    createDeepEqualSelector(
        [selectGroupedData, selectGroupId, selectDate],
        (groupedDataState, groupIdState, dateState) =>
            get(groupedDataState, [`${groupIdState}`, dateState])
    );

export { makeSelectEventUuids };
